import Model from "@/components/common/model.component";
import Image from "next/image";
import AddIcon from "assets/svg/add.svg";
import Form from "@/components/common/form/form";
import { AddLocationService } from "services/addLocatinValve.service";
import LocationForm from "./locationForm";
import _objI from "@/utils/_objI";
import { useTranslation } from "react-i18next";

function locationModal({
  setRefresh,
  showModal,
  setShowModal,
  closeMainModal,
  rowData,
}) {
  const { t } = useTranslation();

  const onSubmit = async (data) => {
    data.geometry = {
      type: "LineString",
      coordinates: data.coordinates.map((items) => [
        Number(items[0]),
        Number(items[1]),
      ]),
    };
    delete data.coordinates;
    data.entity_type_id = 11;
    if (rowData.rowData.gboundary_id) {
      let res = await AddLocationService.editLocation(
        data,
        rowData?.rowData?.gboundary_id
      );
      if (res) {
        setShowModal(false);
        closeMainModal(false);
        setRefresh(1);
      }
    }
  };
  return (
    _objI(rowData) && (
      <>
        <Model
          width="w-96"
          show={showModal}
          onClose={(e) => {
            setShowModal(false);
          }}
        >
          <div className="flex items-center gap-2">
            <Image
              src={AddIcon}
              alt="icon"
              className=" text-mako"
              width="35"
              height="35"
            />
            <h2 className="text-lg font-bold text-mako">
              {t("Edit_Location_Info")}
            </h2>
          </div>

          <Form
            defaultValues={{
              coordinates: rowData?.rowData?.location?.coordinates ?? [],
            }}
            onSubmit={onSubmit}
          >
            <LocationForm passProps />
          </Form>
        </Model>
      </>
    )
  );
}

export default locationModal;
